import type { GetterTree } from 'vuex';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { RootState } from '../../store/root.types';
import type { AuthenticationStepInput } from '../../authentication/types/authentication-step-input';
import { SessionGetter } from './session.types';
import type { SessionState } from './session.types';

export const getters: GetterTree<SessionState, RootState> = {
  [SessionGetter.NextAuthStep](state: SessionState): AuthenticationStep {
    if (!state.authentication.steps.length) {
      return null;
    }
    const sortedSteps: AuthenticationStep[] = [
      ...state.authentication.steps,
    ].sort((step: AuthenticationStep) =>
      step.type === AuthenticationStepType.IdentifyRecipient ? -1 : 1
    );

    return sortedSteps.find((step: AuthenticationStep) => {
      if (
        step.data.error !== false &&
        step.type !== AuthenticationStepType.TrackingConsent &&
        step.type !== AuthenticationStepType.GdprConsent
      ) {
        return !state.authentication.answers.some(
          (input: AuthenticationStepInput) => input.type === step.type
        );
      }
    });
  },

  [SessionGetter.ConsentSteps](state: SessionState): AuthenticationStep[] {
    if (!state.authentication.steps.length) {
      return null;
    }
    return state.authentication.steps.filter(
      (step: AuthenticationStep) =>
        (step.type === AuthenticationStepType.TrackingConsent && step.data.error !== false) ||
        (step.type === AuthenticationStepType.GdprConsent && step.data.error !== false)
    );
  },

  [SessionGetter.DocumentRecalled](state: SessionState): boolean {
    return !!state.status && state.status === DocumentStatus.Recalled;
  },

  [SessionGetter.GDPRDeclined](state: SessionState): boolean {
    if (!state.authentication.steps.length) {
      return false;
    }
    return state.authentication.steps.some(
      (step: AuthenticationStep) =>
        step.type === AuthenticationStepType.GdprConsent && !!step.data.error
    );
  },
};
